(function () {
    'use strict';

    angular
        .module('app')
        .controller('viewError', viewError);

    viewError.$inject = ['$scope', '$mdDialog', 'loginService', 'errorMsgId', 'errorMsg'];

    function viewError(scope, $mdDialog, loginService, errorMsgId, errorMsg) {
        /* jshint validthis:true */
        var vm = this;
        vm.title = 'View';
        if (errorMsgId != '') {
            scope.errorMessage = loginService.resourceStrings[errorMsgId] + errorMsg;
        }
        else
        {
            scope.errorMessage = errorMsg;
        }

        activate(scope);

        function activate(scope) {
            scope.OK = loginService.resourceStrings["OK"]; // "OK";
            scope.heading = loginService.resourceStrings["VIEW"]; // "View";
        }

        scope.onDownloadDialogOK = function () {
            $mdDialog.hide();
        }
    }
})();
